module.exports = __webpack_public_path__ + "static/media/Declined.4b2f1298.png";